<template>
<div :class="$style['goods-specifications']" class="page-background" >
    <div>
        <table>
        <pt-form-list-item label="规格值">
            <div :class="$style['specifications-values']"  @mouseleave="canntDelete()">
                <div :class="$style['specification-value-div']"  v-for="(item,index) in specification" :key="index">
                    <i class="el-icon-error main-color" v-if="item.canDelete" @click="deleteSpeificationVaule(item)"
                    :class="$style['delete-icon-specification']"></i>
                    <wt-input :class="$style['spe-value']" v-model="item.name" :disabled="item.itemId==='gene_unlock'||item.itemId==='gene_default'" data-vv-as="规格值" name="name"
                    @mouseenter.native="canDelete(item)" v-validate="'required'"  @blur="specificationValue(item,index)"></wt-input>
                </div>
                <el-button type="text" @click="addSpeValue" :class="$style['add-spe-button']" v-if="allowAddSpecifications">添加规格值</el-button>
                <el-button v-if="!has_unlock" type="text" @click="addUnlock(item)">添加“开启报告内容（无需采样）”规格</el-button>
            </div>
        </pt-form-list-item>
    </table>
    </div>
</div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    justShow: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    allowAddSpecifications: Boolean
  },
  data () {
    return {
      specification: this.value,
      has_unlock: this.type !== 'GENE',
      oldSpecificationValue: {}
    }
  },
  watch: {
    value: {
      handler: function (val) {
        this.specification = val
        val.forEach(item => {
          if (item.itemId === 'gene_unlock') {
            this.has_unlock = true
          }
        })
        if (this.justShow) {
          this.has_unlock = true
        }
      },
      immediate: true
    }
  },
  methods: {
    // 规格值验重
    specificationValue (etem, i) {
      this.specification.forEach((item, index) => {
        if (etem.name && item.name === etem.name && i !== index) {
          this.$message.error('请填写非重复的规格')
          etem.name = null
        }
      })
    },
    // 添加‘开启报告内容（无需采样）’规格
    addUnlock (val) {
      val.push({ itemId: 'gene_unlock', name: '开启报告内容（无需采样）' })
      this.has_unlock = true
    },
    // 添加规格值
    addSpeValue (val) {
      this.oldSpecificationValue = JSON.parse(JSON.stringify(val))
      this.specification.push({
        name: '', // 明细项id
        stockQuantity: '',
        price: '' // 影响的价格
      })
      // 更新视图
      this.specification.sort()
    },
    // 鼠标进入某商品规格值的区域时，出现‘✘’按钮，可删除改商品规格值
    canDelete (val) {
      this.specification.forEach(item => {
        if (JSON.stringify(item) === JSON.stringify(val)) {
          this.$set(item, 'canDelete', true)
        }
      })
      this.$emit('input', this.specification)
    },
    // 鼠标离开某商品规格值时，隐藏‘✘’按钮，不可删除商品规格值
    canntDelete () {
      this.specification.forEach(item => {
        this.$set(item, 'canDelete', false)
      })
      this.specification = Object.assign([], this.specification)
      this.$emit('input', this.specification)
    },
    // 删除某商品规格值
    deleteSpeificationVaule (val) {
      this.specification.forEach((item, index) => {
        if (JSON.stringify(item) === JSON.stringify(val)) {
          this.specification.splice(index, 1)
        }
      })
      if (val.itemId === 'gene_unlock' && !this.justShow && this.type === 'GENE') {
        this.has_unlock = false
      }
    },
    deleteSpeificationName (val) {
      this.specification = []
      this.$emit('input', this.specification)
    },
    // 鼠标进入某商品规格名的区域时，出现‘✘’按钮，可删除改商品规格名
    specificationEnter (val) {
      this.specification.forEach((item, index) => {
        if (JSON.stringify(item) === JSON.stringify(val)) {
          this.$set(item, 'canDelete', true)
        }
      })
      this.$emit('input', this.specification)
    },
    // 鼠标离开某商品规格名时，隐藏‘✘’按钮
    specificationLeave () {
      this.specification.forEach((item, index) => {
        this.$set(item, 'canDelete', false)
      })
      this.$emit('input', this.specification)
    }
  }
}
</script>
<style lang="less" module>
.goods-specifications{
    padding: 20px 20px 0;
    box-sizing: border-box;
    flex: 1
}
.goods-specification{
    width: 100%;
    max-width: 100%!important;
    display: flex;
    :global
    &:last-child{
        display: flex
    }
}
.specifications-values{
    display: flex;
    flex-wrap:wrap
}
.spe-value{
    // width: 180px;
    width: auto;
    max-width: 220px;
    margin:0 10px 10px 0;
}
.add-spe-button{
    margin-left: 15px;
    font-size: 15px;
}
.specifications-name{
    width: 180px;
}

.specification-value-div{
    position: relative
}
.delete-icon-specification{
    position: absolute;
    z-index: 10;
    top: -5px;
    right: 5px;
}
.specification-name-div{
    position: relative;
    display: inline-flex;
    :global
    .el-icon-error{
        right: -5px;
    }
}
</style>
